// import { useForm } from "hooks/useForm"
import Button, { ButtonWrapper } from 'blocks/Button';
import Form, { TextField } from 'components/Form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import * as S from '../Profile.styles';
import { NewPasswordFormModel } from '../profile.interface';

const NewPassword = () => {
  const { t } = useTranslation();
  const { register, getValues } = useForm<NewPasswordFormModel>();
  const submit = () => {
    const password = getValues('password');
    const reEnterPassword = getValues('reEnterPassword');
    if (password === reEnterPassword) {
      // handleSubmit();
    } else {
      toast.error('شبیه نیست');
    }
  };

  return (
    <S.ProfileCard>
      <S.ProfileHead>
        {/* TODO text issue */}
        <S.ProfileBoxTitle>تغییر رمز</S.ProfileBoxTitle>
      </S.ProfileHead>

      <Form>
        <S.ChangePasswordtWrapper>
          <TextField
            control={register('password')}
            label={t('pages.profile.sections.securityDetails.form.fields.oldPassword')}
          />

          <TextField
            control={register('reEnterPassword')}
            label={t('pages.profile.sections.securityDetails.form.fields.confirmPassword')}
          />
        </S.ChangePasswordtWrapper>

        <S.ButtonWrapper as={ButtonWrapper} justify="flex-end">
          {/* TODO text issue */}
          <S.Button as={Button} onClick={() => submit()}>
            اعمال تغییر
          </S.Button>
        </S.ButtonWrapper>
      </Form>
    </S.ProfileCard>
  );
};

export default NewPassword;
